export enum IconGropus {
    Wizard = 1
}
